import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Card, CardBody, CardHeader, InputGroup, Input, Button, Label , Alert} from 'reactstrap'
import { connect } from 'react-redux'
import { ErrorMessage } from './NewManageUsers/ManagePane/InfoCard/ActionBlockComponents'
import validatePassword from '../../helpers/users/manageUsers/validatePassword'
import overridePassword from '../../helpers/users/manageUsers/overridePassword'
import pingPasswordFunc from '../../helpers/users/manageUsers/pingPasswordFunc'

class UserProfilePassword extends Component {

  state = {
    saving: false,
    saved: false,
    password: '',
    passwordConfirm: '',
    error: '',
    changed: false,
  }

  componentDidMount() {
    const { user } = this.props
    pingPasswordFunc(user.role).catch(err => console.log(err))
  }

  oChg = ({target}) => this.setState({
    [target.name]: target.value, 
    changed: true,
    saved: false,
  }) 

  saveNewPW = () => {
    const { password, passwordConfirm } = this.state
    const { user } = this.props
    this.setState({saving: true})
    const validationError = validatePassword(password, passwordConfirm)
    if (validationError) {
      this.setState({saving: false, error: validationError})
    } else {
      
      overridePassword(user, password)
        .then(() => this.setState({
          saving: false, 
          saved: true, 
          changed: false, 
          error: '', 
          password: '',
          passwordConfirm: '',
        }))
        .catch(err => this.setState({
          error: 'Error saving password.', 
          saving: false, 
          saved: false, 
          changed: true
        }))
    }
  }

  render() {
   
    const { password, passwordConfirm, saving, saved, error, changed } = this.state
    return (
      <Card>
        <CardHeader>
          Change Your Password
        </CardHeader>
        <CardBody>
        <div className="input-group-wrap">
          <InputGroup>
            <Label htmlFor='password'>New Password:</Label>
            <Input
              type='password'
              value={password}
              onChange={this.oChg}
              name='password'
              id='password'
              invalid={error === 'Password required.'}
            />
          </InputGroup>
          <InputGroup>
            <Label htmlFor='passwordConfirm'>Confirm New Password:</Label>
            <Input
              type='password'
              value={passwordConfirm}
              onChange={this.oChg}
              name='passwordConfirm'
              id='passwordConfirm'
              invalid={error === 'Passwords do not match.'}
            />
          </InputGroup>
          </div>
          <div className="profile-btns">
          <Button className="active-btn"
            disabled={!(changed) || !!saved}
            onClick={this.saveNewPW}  
          >
            {saving
              ? <BeatLoader loading={saving} />
              : (saved ? 'Saved' : 'Save')
            }
          </Button>
          <Link to='user/profile'>
            <Button disabled={!!saving}>Cancel</Button>
          </Link>
          </div>
          {error &&
            <Alert color="warning" className = "mt-3">{error}</Alert>  
          }
          <div className="back-to-profile">
            <Link to='user/profile'>{'< Return to Profile'}</Link>
          </div>
        </CardBody>
      </Card>
    )
  }
}

export default connect(
  (state) => ({
    user: state.users.testUser,
  })
)(UserProfilePassword)


// WEBPACK FOOTER //
// ./src/components/Users/UserProfilePassword.js